type PrintTemplates = typeof import('./browser-print-template');

let templates: PrintTemplates | null = null;
let arriving: Promise<PrintTemplates> | null = null;

export class PrintTemplatesNotReadyError extends Error {
  constructor() {
    super('The print templates have not been loaded yet');
    this.name = 'PrintTemplatesNotReadyError';
  }
}

/**
 * The print templates and their styles, fetched the way the sanitizer is: warmed while the reader
 * looks at the screen, so that a tap on "print" finds them in hand and awaits nothing. They are
 * not needed before a document is printed, so they stay out of the first download.
 */
export const preloadPrintTemplates = async (): Promise<void> => {
  if (templates !== null) return;
  arriving ??= import('./browser-print-template');
  templates = await arriving;
};

export const arePrintTemplatesReady = (): boolean => templates !== null;

/** The loaded templates; asking before they have arrived is a programming error. */
export const printTemplates = (): PrintTemplates => {
  if (templates === null) throw new PrintTemplatesNotReadyError();
  return templates;
};
